import { Color } from '@billy/design-system'

export const AVATAR_COLORS = [Color.Purple100, Color.Yellow100, Color.Green100, Color.Orange100]
